export const ToggleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.998698 4.9974V2.9974H9.9987V0.664062L13.332 3.9974L9.9987 7.33073V4.9974H0.998698ZM12.9987 10.9974V8.9974H3.66536V6.66406L0.332031 9.9974L3.66536 13.3307V10.9974H12.9987Z"
        fill="var(--colors-text-secondary)"
      />
    </svg>
  )
}
